import { Component, Inject, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-ticket-warning-modal',
    templateUrl: './ticket-warning-modal.component.html',
    styleUrls: ['./ticket-warning-modal.component.scss']
})
export class TicketWarningModalComponent implements OnInit {
    @Input() duration?: number;

    constructor(
        private modalCtrl: ModalController,
        private translate: TranslateService,
        @Inject('ENV') public env: Env
    ) {}

    title: string;
    hours: number;

    ngOnInit() {
        if (this.duration > 1 && this.duration < 3) {
            this.hours = 1;
            this.title = 'TICKET_WARNING_VALID_HOUR_TITLE';
        } else if (this.duration > 3) {
            this.hours = 3;
            this.title = 'TICKET_WARNING_VALID_HOURS_TITLE';
        }
    }

    async close(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }
}
